import React, { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const ViewershipDataAuditConnector = React.lazy(
  () => import('components/Tools/ViewershipDataAudit/ViewershipDataAudit'),
);

function ScreensToolsViewershipDataAudit() {
  const hasViewershipDataAuditEnabled = useFeatureFlagEnabled(
    'ViewershipDataAudit',
  );

  if (hasViewershipDataAuditEnabled === false) {
    return <Navigate to="/tools" replace />;
  }

  // Still loading feature flag
  if (hasViewershipDataAuditEnabled === undefined) {
    return (
      <BaseLayout>
        <UILoader />
      </BaseLayout>
    );
  }

  return (
    <BaseLayout>
      <DocumentTitle>Viewership Data Audit</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ViewershipDataAuditConnector />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensToolsViewershipDataAudit;
